



const Content = ({ attributes, reverseString }) => {

    const { content } = attributes;
    const revText = reverseString(content?.text);
    return <span>{revText}<div id='innerContainer'></div></span>
}
export default Content;